import {createSelector} from '@ngrx/store';

import * as fromRegionsReducer from './regions.reducer'
import {AppState} from 'src/app/store/reducers';
import {Regions} from "./regions.model";
import {FeedbackComplaint} from "../../feedback/feedback.model";
import {selectModifiedFeedbacks} from "../../feedback/feedback.selectors";


export const currentState = (state: AppState) => (state[fromRegionsReducer.regionsesFeatureKey]);

export const selectAllRegions = createSelector(currentState, fromRegionsReducer.selectAll);

export const selectTotalRegions = createSelector(currentState, fromRegionsReducer.selectTotal);

export const selectModifiedRegions = createSelector(selectAllRegions, (regions) => {
  return regions.map((region) => {
    return {
      ...regions
    };
  });
});

export const selectRegionByUid = (regionUniqueId: string) =>
  createSelector(selectModifiedFeedbacks, (region: Regions[]) => {
    return region.find((region) => region?.regionalUniqueId === regionUniqueId);
  });

